import React, { useEffect, useState } from "react";
import {
    Badge, Button, CircularProgress, Grid, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme
} from "@mui/material";
import { connect } from "react-redux";
//--------------------------|| 3RD PARTY LIBRARIES ||------------------------------------//
import {
    IconEdit,
    IconFilter,
    IconPlaylistAdd,
    IconSortAscending2,
    IconSortDescending2
} from "@tabler/icons-react";
//--------------------------|| FILES IMPORT ||------------------------------------------//
import { getPager } from "helper/common";
import MainCard from "ui-component/cards/MainCard";
import SubCard from "ui-component/cards/SubCard";
import { NoData } from "ui-component/custom-components/nodata";
import { VWPagination } from "ui-component/custom-components/pagination";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import Chip from "ui-component/extended/Chip";
import {
    appVersionListErrorClear,
    clearAppVersionList,
    closeAppVersionCreateDialog,
    closeAppVersionEditDialog,
    closeAppVersionFilterDialog,
    getAppVersionDetails,
    getAppVersionList,
    openAppVersionCreateDialog,
    openAppVersionFilterDialog,
    setAppVersionFilteredData
} from "store/app/app-management/app-version/actions";
import moment from "moment";
import AddAppVersion from "./create";
import FilterAppVersion from "./filter";
import EditAppVersion from "./edit";
import { IconBrandAndroid } from "@tabler/icons-react";
import { downloadAPKErrorClear, getDownloadAPK } from "store/app/download-APK/actions";

const tableHeaderStyle = { paddingLeft: '0px' }

const AppVersionList = (props) => {
    //--------------------List--------------------------------------
    const { appVersionList, totalCounts, isPending, errorMessage } = props;

    const [pageSize, setPageSize] = useState(10);
    const [Pager, setPager] = useState({ currentPage: 1 });
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);

    //--------------------Filter------------------------------------
    const { appVersionFilterData, isAppVersionFilterDialogOpen } = props;
    //--------------------Create------------------------------------
    const { isAppVersionCreateDialogOpen } = props;
    //--------------------Edit--------------------------------------
    const { isAppVersionEditDialogOpen, appVersionDetailsPending } = props;
    //--------------------Profile-----------------------------------
    const { userProfile } = props;
    const { userRoleName } = userProfile || {};
    //--------------------Download APK------------------------------
    const { isDownloadPending, downloadErrorMessage } = props;

    //--------------------UI Design---------------------------------
    const theme = useTheme();
    const colorPrimary = theme.palette.secondary.dark;
    const [tableHeight, setTableHeight] = useState(window.innerHeight);

    //---------------------------------------------------------------------------------------//
    useEffect(() => {
        props.appVersionListErrorClear();
        props.downloadAPKErrorClear();

        const handleResize = () => {
            setTableHeight(window.innerHeight)
        };
        window.addEventListener("resize", handleResize);

        return () => {
            props.clearAppVersionList();
            window.removeEventListener("resize", handleResize);
        }
    }, [])

    //--------------------------|| SORTING ||------------------------------------------//
    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        }
        else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };

    //--------------------------|| PAGINATION ||------------------------------------------//
    const setPage = (page = 1) => {
        props.getAppVersionList(page, pageSize, sortOrder, sortDirection, appVersionFilterData);

        setPager(prevPager => {
            const totalPages = Math.ceil(totalCounts / pageSize);
            const visiblePages = 4;
            const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
            const newPages = [];
            for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
                newPages.push(i);
            }
            return {
                ...prevPager,
                currentPage: page,
                totalPages,
                pages: newPages,
            }
        })
    }

    useEffect(() => {
        const currentPager = getPager(totalCounts, 1, pageSize);
        setPager(currentPager)
    }, [totalCounts]);

    useEffect(() => {
        setPage();
    }, [appVersionFilterData, sortOrder, sortDirection, pageSize]);

    //--------------------------|| CREATE DIALOG ||------------------------------------------//
    const handleAppVersionCreateOpen = () => {
        props.openAppVersionCreateDialog();
    }

    const handleAppVersionCreateClose = () => {
        props.closeAppVersionCreateDialog();
    }
    //--------------------------|| EDIT DIALOG ||------------------------------------------//
    const handleAppVersionEditOpen = (id) => {
        props.getAppVersionDetails(id);
    }

    const handleAppVersionEditClose = () => {
        props.closeAppVersionEditDialog();
    }
    //--------------------------|| FILTER DIALOG ||------------------------------------------//
    const handleFilterOpen = () => {
        props.openAppVersionFilterDialog();
    }

    const handleFilterClose = () => {
        props.closeAppVersionFilterDialog();
    }
    //--------------------------|| DOWNLOAD APK ||-------------------------------------------//
    const handledownload = (e) => {
        e.preventDefault();
        props.getAPKFile();
    }

    return (
        <>
            {/*----------------------------|| HEADER ||--------------------------------*/}
            <SubCard sx={{
                p: 1.5,
                pl: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
            >
                <Grid item sx={{ display: 'flex', gap: { lg: 2, md: 2, sm: 1, xs: 1 }, alignItems: "center", marginRight: "10px" }}>
                    <Typography variant="h4">App Versions List - </Typography>
                    <Tooltip title="App Version Count" placement="top">
                        <span>
                            <Chip
                                label={totalCounts}
                                chipcolor="secondary"
                                size="small"
                                sx={{
                                    borderRadius: "20%",
                                    py: 1,
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    cursor: "pointer"
                                }}
                            />
                        </span>
                    </Tooltip>
                </Grid>
                <Grid item sx={{ display: 'flex', gap: 2 }}>
                    <Badge
                        badgeContent={appVersionFilterData ? Object.keys(appVersionFilterData).length : 0}
                        color="secondary"
                        invisible={appVersionFilterData ? Object.keys(appVersionFilterData).length === 0 : true}
                    >
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleFilterOpen}
                            startIcon={<IconFilter />}
                        >
                            Filter
                        </Button>
                    </Badge>
                    {(userRoleName === "Administrator" || userRoleName === "Master admin") &&
                        <div>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleAppVersionCreateOpen}
                                startIcon={<IconPlaylistAdd />}
                            >
                                Add App Version
                            </Button>
                        </div>
                    }
                    <Button
                        sx={{ ml: 2 }}
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={handledownload}
                        startIcon={<IconBrandAndroid />}
                        disabled={isDownloadPending}
                    >
                        {isDownloadPending ?
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <CircularProgress size={'20px'} color='inherit' />
                                Downloading...
                            </div>
                            : <> Download APK</>
                        }
                    </Button>
                </Grid>
            </SubCard>
            {/*----------------------------|| TABLE ||--------------------------------*/}
            <MainCard sx={{ marginTop: '15px' }}>
                {(errorMessage || downloadErrorMessage) && <ErrorAlert type={'error'} content={errorMessage || downloadErrorMessage} />}
                <TableContainer sx={{ maxHeight: `calc(${tableHeight}px - 380px)`, overflow: "auto" }}>
                    <Table size="small" stickyHeader aria-label="sticky table"
                        sx={{
                            '& tr > *:last-child': {
                                position: 'sticky',
                                right: 0,
                                bgcolor: 'white',
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('VersionNo')}
                                        endIcon={sortOrder === 'VersionNo' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Version No
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('AppName')}
                                        endIcon={sortOrder === 'AppName' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        App Name
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('ReleasedDate')}
                                        endIcon={sortOrder === 'ReleasedDate' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Released Date
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button sx={tableHeaderStyle}
                                        onClick={() => handleSort('Notes')}
                                        endIcon={sortOrder === 'Notes' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Notes
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('CreatedBy')}
                                        endIcon={sortOrder === 'CreatedBy' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Created By
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('UpdatedBy')}
                                        endIcon={sortOrder === 'UpdatedBy' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Updated By
                                    </Button>
                                </TableCell>
                                {(userRoleName !== "User") &&
                                    <TableCell>Action</TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(appVersionList?.length > 0) && !isPending ?
                                appVersionList?.map((data, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{data.VersionNo || 'N/A'}</TableCell>
                                        <TableCell>{data.AppName || 'N/A'}</TableCell>
                                        <TableCell>{data.ReleasedDate ? moment(data.ReleasedDate).format('DD MMM YYYY') : 'N/A'}</TableCell>
                                        <TableCell>
                                            <Tooltip title={data.Notes} placement="top">
                                                {data.Notes ?
                                                    data.Notes?.length > 30 ?
                                                        data.Notes?.substring(0, 30) + '...'
                                                        : data.Notes
                                                    : 'N/A'
                                                }
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            {data.CreatedBy || 'N/A'}<br />
                                            <small>{data.CreatedTimeStamp ? moment(data.CreatedTimeStamp).format('DD MMM YYYY') : 'N/A'}</small>
                                        </TableCell>
                                        <TableCell>
                                            {data.UpdatedBy || 'N/A'}<br />
                                            <small>{data.UpdatedTimeStamp ? moment(data.UpdatedTimeStamp).format('DD MMM YYYY') : 'N/A'}</small>
                                        </TableCell>
                                        {(userRoleName !== "User") &&
                                            <TableCell>
                                                {appVersionDetailsPending === data.Id ?
                                                    <Grid container gap={1}>
                                                        <CircularProgress size={20} />
                                                        <Typography variant="h6" color={'primary'}> Loading...</Typography>
                                                    </Grid>
                                                    :
                                                    <Tooltip title="Edit App Version" placement="top">
                                                        <IconEdit style={{ cursor: "pointer" }} onClick={() => handleAppVersionEditOpen(data.Id)} />
                                                    </Tooltip>
                                                }
                                            </TableCell>
                                        }
                                    </TableRow>
                                ))
                                /*--------|| LOADING ||---------*/
                                : isPending ?
                                    <TableRow >
                                        <TableCell colSpan={8} height='300px'>
                                            <Grid container alignItems={"center"} justifyContent={"center"} gap={1}
                                                sx={{
                                                    position: "sticky",
                                                    width: "fit-content",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)"
                                                }}
                                            >
                                                <CircularProgress />
                                                <Typography variant="h5" color={'primary'}> Loading...</Typography>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                    /*--------|| NO DATA ||---------*/
                                    : <TableCell colSpan={8} height='300px'>
                                        <NoData />
                                    </TableCell>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                {/*--------|| PAGINATION ||---------*/}
                <Grid>
                    <VWPagination
                        pageDetails={Pager}
                        pageChange={setPage}
                        totalRecords={totalCounts}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </Grid>
            </MainCard>

            {/*--------|| CREATE DIALOG ||---------*/}
            <AddAppVersion
                filter={appVersionFilterData}
                paginationData={{
                    page: (Pager && Pager.currentPage) || 1,
                    pageSize: pageSize,
                    sortDirection: sortDirection,
                    sortOrder: sortOrder
                }}
                open={isAppVersionCreateDialogOpen}
                onClose={handleAppVersionCreateClose}
            />
            {/*--------|| EDIT DIALOG ||---------*/}
            <EditAppVersion
                filter={appVersionFilterData}
                paginationData={{
                    page: (Pager && Pager.currentPage) || 1,
                    pageSize: pageSize,
                    sortDirection: sortDirection,
                    sortOrder: sortOrder
                }}
                open={isAppVersionEditDialogOpen}
                onClose={handleAppVersionEditClose}
            />

            {/*--------|| FILTER DIALOG ||---------*/}
            <FilterAppVersion
                open={isAppVersionFilterDialogOpen}
                onClose={handleFilterClose}
                setPage={setPage}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    //--------------------List--------------------------------------
    appVersionList: state.appVersions.appVersionList,
    totalCounts: state.appVersions.appVersionListCount,
    isPending: state.appVersions.isAppVersionListPending,
    errorMessage: state.appVersions.appVersionListErrorMessage,
    //--------------------Filter------------------------------------
    isAppVersionFilterDialogOpen: state.appVersions.isAppVersionFilterDialogOpen,
    appVersionFilterData: state.appVersions.appVersionFilterData,
    //--------------------Create------------------------------------
    isAppVersionCreateDialogOpen: state.appVersions.isAppVersionCreateDialogOpen,
    //--------------------Edit--------------------------------------
    appVersionDetailsPending: state.appVersions.appVersionDetailsPending,
    isAppVersionEditDialogOpen: state.appVersions.isAppVersionEditDialogOpen,
    //--------------------Profile-----------------------------------
    userProfile: state.login.userProfile,
    //--------------------Download APK------------------------------
    isDownloadPending: state.downloadAPK.isDownloadAPKPending,
    downloadAPKSuccess: state.downloadAPK.downloadAPKSuccess,
    downloadErrorMessage: state.downloadAPK.downloadAPKErrorMessage,
})

const mapDispatchToProps = (dispatch) => ({
    //--------------------List--------------------------------------
    getAppVersionList: (page, pageSize, sortOrder, sortDirection, filter) => dispatch(getAppVersionList(page, pageSize, sortOrder, sortDirection, filter)),
    clearAppVersionList: () => dispatch(clearAppVersionList()),
    appVersionListErrorClear: () => dispatch(appVersionListErrorClear()),
    //--------------------Filter------------------------------------
    openAppVersionFilterDialog: () => dispatch(openAppVersionFilterDialog()),
    closeAppVersionFilterDialog: () => dispatch(closeAppVersionFilterDialog()),
    setAppVersionFilteredData: (filter) => dispatch(setAppVersionFilteredData(filter)),
    //--------------------Create------------------------------------
    openAppVersionCreateDialog: () => dispatch(openAppVersionCreateDialog()),
    closeAppVersionCreateDialog: () => dispatch(closeAppVersionCreateDialog()),
    //--------------------Edit--------------------------------------
    getAppVersionDetails: (id) => dispatch(getAppVersionDetails(id)),
    closeAppVersionEditDialog: () => dispatch(closeAppVersionEditDialog()),
    //--------------------Download APK------------------------
    getAPKFile: () => dispatch(getDownloadAPK()),
    downloadAPKErrorClear: () => dispatch(downloadAPKErrorClear()),
})
export default connect(mapStateToProps, mapDispatchToProps)(AppVersionList);